import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { DSOK_POS_SUPPLIERS, DSOK_EKASA_TYPES } from "app/utils/constants/settings";

const STEP_TITLE = "Kiosky";

/**
 * Step 4: Kiosky – number of kiosks, POS provider, eKasa provider.
 * All fields required.
 */
const Step4Kiosky = ({ values, errors, onChange }) => {
  const { t } = useTranslation();

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    if (field === "deviceCount") {
      const parsed = value === "" ? "" : parseInt(value, 10);
      onChange(field, parsed === "" || Number.isNaN(parsed) ? value : parsed);
    } else {
      onChange(field, value);
    }
  };

  const deviceCountValue = values.deviceCount;
  const displayKiosky =
    deviceCountValue === "" || deviceCountValue === undefined || deviceCountValue === null
      ? ""
      : String(deviceCountValue);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {STEP_TITLE}
        </Typography>
        <Grid container spacing={3} sx={{ pt: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Počet kioskov *"
              value={displayKiosky}
              onChange={handleChange("deviceCount")}
              error={!!errors.deviceCount}
              helperText={errors.deviceCount}
              variant="outlined"
              inputProps={{ min: 1, step: 1 }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth error={!!errors.posProvider}>
              <InputLabel>POS provider *</InputLabel>
              <Select
                value={values.posProvider ?? ""}
                onChange={handleChange("posProvider")}
                label="POS provider *"
              >
                {DSOK_POS_SUPPLIERS.map(({ code, name }) => (
                  <MenuItem key={code} value={code}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
              {errors.posProvider && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                  {errors.posProvider}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth error={!!errors.ekasaProvider}>
              <InputLabel>eKasa provider *</InputLabel>
              <Select
                value={values.ekasaProvider ?? ""}
                onChange={handleChange("ekasaProvider")}
                label="eKasa provider *"
              >
                {DSOK_EKASA_TYPES.map(({ code, name }) => (
                  <MenuItem key={code} value={code}>
                    {t(`pages.dsokDetails.${name}`)}
                  </MenuItem>
                ))}
              </Select>
              {errors.ekasaProvider && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
                  {errors.ekasaProvider}
                </Typography>
              )}
            </FormControl>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Step4Kiosky;
